
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.647 1.333H2.354a.967.967 0 00-.98.953v11.427a.966.966 0 00.98.953h11.293a.967.967 0 00.98-.953V2.286a.968.968 0 00-.98-.953zm-8.253 11.16h-2v-6h2v6zm-1-6.84a1.04 1.04 0 110-2.08 1.047 1.047 0 110 2.08zm8.213 6.84h-2v-3.22c0-.807-.287-1.333-1.013-1.333a1.1 1.1 0 00-1.027.726 1.333 1.333 0 00-.067.487v3.333h-2v-6h2v.847a2 2 0 011.807-1c1.333 0 2.3.86 2.3 2.707v3.453z","fill":"currentColor"}})])
          )
        }
      }
    